import http from "@/http/axios";
import { appModule } from "@/store/modules/app";

function errorMessage(result, fallback: string) {
  return result?.data?.message?.zh || fallback;
}

export async function getCommunityList() {
  const result = await http.get(`/place/community-list`);
  if (result && result.data.status === "Success") {
    return result.data.data.community_list;
  }
  appModule.sendErrorNotice(errorMessage(result, "取得社區清單失敗"));
  return [];
}

export async function updateCommunityList(communityList: string[]) {
  const result = await http.put(`/place/community-list`, { community_list: communityList });
  if (result && result.data.status === "Success") {
    appModule.sendSuccessNotice("社區清單更新成功");
    return result.data.data.community_list;
  }
  appModule.sendErrorNotice(errorMessage(result, "社區清單更新失敗"));
  return null;
}

export async function getFilteredIid() {
  const result = await http.get(`/place/filtered-iid`);
  if (result && result.data.status === "Success") {
    return result.data.data.filtered_iid;
  }
  appModule.sendErrorNotice(errorMessage(result, "取得篩選名冊失敗"));
  return [];
}

export async function updateFilteredIid(filteredIid: string[]) {
  const result = await http.put(`/place/filtered-iid`, { filtered_iid: filteredIid });
  if (result && result.data.status === "Success") {
    appModule.sendSuccessNotice("篩選名冊更新成功");
    return result.data.data.filtered_iid;
  }
  appModule.sendErrorNotice(errorMessage(result, "篩選名冊更新失敗"));
  return null;
}
